import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";
import CacheStorage from "../modules/cacheStorage";
const initState = {
  areas: [],
  areasCount: 0,
  actionManagers: [],
  eventListeners: [],
  areaTypes: [],
  isLoading: true,
  isModified: false,
  areaTypesLoaded: false,
  isTransportCompleted: undefined, // true for successful, false for failed, undefined as default state.
  buildings: [],
  buildingsLoaded: false,
  parkings: [],
  parkingsLoaded: false,
  touchPanelAlert: null, // queueId<string> delay<int> areaId<int> areaUId<string> areaName<string> pinCode<string>
  isPlayingAlarm: false,
};

const AreaReducer = (state = initState, action) => {
  // if (state.areas.length == 0) {
  //   var areas = new CacheStorage().Areas.GetAll()
  //     .then((areas) => {
  //       if (Array.isArray(areas) && areas.length > 0) {
  //         state.areas = areas;
  //         state.isLoading = false;
  //       }
  //     })
  //     .catch(console.log);
  // }

  const _state = { ...state };
  if (action.type == Pre.AREA + Actions.REFRESH) {
    _state.isModified = false; // turn off flag to prevent recursive call.
  }
  if (action.socket && action.socket.send) {
    // leave request to handle by server
    if (
      action.type.indexOf(Pre.AREA + Actions.ACTIVE_STATE) == 0 ||
      action.type.indexOf(Pre.AREA + Actions.DE_ACTIVE_STATE) == 0
    ) {
      // console.log('areaReducer allow pass action', action.type)
      // allow pass
    } else {
      return _state;
    }
  }
  var parsedData = null;
  if (action.payload && action.payload.data) {
    parsedData = JSON.parse(action.payload.data);
  }

  const findAreaById = (areaId) => {
    for (var i in _state.areas) {
      if (typeof areaId == "number") {
        if (_state.areas[i].areaId == areaId) {
          return _state.areas[i];
        }
      } else {
        if (_state.areas[i].areaUId == areaId) {
          return _state.areas[i];
        }
      }
    }
  };
  // else apply locally
  switch (action.type) {
    case Pre.AREA + Actions.ADD:
      var model = JSON.parse(action.payload.data);
      _state.areas.push(model);
      if (model.parentAreaId || model.parentAreaUId) {
        for (var ar in _state.areas) {
          // if (
          //   _state.areas[ar].areaId == model.parentAreaId ||
          //   (model.parentAreaUId &&
          //     _state.areas[ar].areaUId &&
          //     _state.areas[ar].areaUId == model.parentAreaUId)
          // )
          if (
            _state.areas[ar].areaUId == model.parentAreaUId ||
            (!model.parentAreaUId &&
              _state.areas[ar].areaId == model.parentAreaId)
          ) {
            if (!_state.areas[ar].subAreas) _state.areas[ar].subAreas = [];
            _state.areas[ar].subAreas.push(model);
            break;
          }
        }
      }
      _state.isLoading = false;
      _state.areasCount++;
      new CacheStorage().Areas.SetAll(_state.areas);
      break;
    case Pre.AREA + Actions.UPDATE:
      model = JSON.parse(action.payload.data);
      if (model) {
        _state.areas.map((ar) => {
          if (ar.areaId == model.areaId || ar.areaUId == model.areaUId) {
            ar.areaName = model.areaName;
            ar.areaType = model.areaType;
            ar.areaTypeId = model.areaTypeId;
            ar.imageSource = model.imageSource;
            ar.isArmable = model.isArmable;
            ar.rolesAllowedToArm = model.rolesAllowedToArm;
            ar.showOnHomeScreen = model.showOnHomeScreen;
            ar.extra = model.extra || {};
            return;
          }
        });
      }
      _state.isLoading = false;
      new CacheStorage().Areas.SetAll(_state.areas);
      break;
    case Pre.AREA + Actions.REMOVE:
      let { areaId, areaUId } = parsedData;
      if (areaId || areaUId) {
        //  // === filter area by id & uId ===
        //  newAreas = newAreas.filter(
        //   (area) => area.areaId !== areaId && area.areaUId !== areaUId
        // );
        // // === filter subArea by id & uId ===
        // newAreas.forEach((newArea) => {
        //   let newSubAreas = [...newArea.subAreas];
        //   newSubAreas = newSubAreas.filter((newSubArea) => {
        //     if (typeof newSubArea === "object") {
        //       newSubArea.areaId !== areaId && newSubArea.areaUId !== areaUId;
        //     } else if (
        //       typeof newSubArea === "number" ||
        //       typeof newSubArea === "string"
        //     ) {
        //       newSubArea !== areaId && newSubArea !== areaUId;
        //     }
        //   });
        //   newArea.subAreas = newSubAreas;
        // });
        for (var i in _state.areas) {
          if (
            _state.areas[i].areaId == areaId ||
            _state.areas[i].areaUId == areaUId
          ) {
            // removing i_th element using splice(index , length)
            _state.areas.splice(i, 1);

            break;
          }
        }

        for (var i in _state.areas) {
          if (Array.isArray(_state.areas[i].subAreas)) {
            // removing i_th element using splice(index , length)
            for (var j in _state.areas[i].subAreas) {
              if (
                _state.areas[i].subAreas[j].areaId == areaId ||
                _state.areas[i].subAreas[j].areaUId == areaUId
              ) {
                _state.areas[i].subAreas.splice(j, 1);
              }
            }

            break;
          }
        }
      }
      // console.log("_state.areas", _state.areas);
      _state.isLoading = false;
      new CacheStorage().Areas.SetAll(_state.areas);
      break;
    case Pre.AREA + Actions.ALL:
      // var areas = JSON.parse(action.payload);
      if (parsedData && Array.isArray(parsedData)) {
        var areas = parsedData;
        if (areas) {
          _state.areas = areas;
          _state.areasCount = areas.length;
          new CacheStorage().Areas.SetAll(_state.areas);
        }
      }
      _state.isModified = false; // all changes synced. so update 'isModified' to false.
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.ALL_CACHE:
      if (Array.isArray(action.payload)) {
        _state.areas = action.payload;
      }
      break;
    case Pre.AREA + Actions.CLEAR:
      _state.areas = [];
      new CacheStorage().Areas.ClearAll();
      break;
    case Pre.AREA + Actions.TYPE_ALL:
      if (Array.isArray(parsedData)) {
        _state.areaTypes = [...parsedData];
        _state.areaTypesLoaded = true;
      }
      break;
    case Pre.AREA + Actions.ARMED_CHANGE:
      var model = JSON.parse(action.payload.data);
      if (model) {
        _state.areas.map((ar) => {
          if (ar.areaId == model.areaId || ar.areaUId == model.areaUId) {
            ar.isArmed = model.isArmed;
            return;
          }
        });
      }
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.COPY_DEVICES_TO_AREAS:
      if (parsedData) {
        for (var r in parsedData) {
          // parsed data contains 'targetAreaId' , 'devices' , 'oldAreaId'
          var targetArea = findAreaById(
            parsedData[r].targetAreaId || parsedData[r].targetAreaUId
          );
          if (targetArea) {
            if (
              !targetArea.devices ||
              (!targetArea.uDevices !== null &&
                targetArea.uDevices !== undefined &&
                !targetArea.uDevices)
            ) {
              targetArea.devices = parsedData[r].devices;
              targetArea.uDevices = parsedData[r].uDevices;
            } else {
              if (parsedData[r].devices) {
                for (var d in parsedData[r].devices) {
                  var newDv = parsedData[r].devices[d];
                  if (targetArea.devices.indexOf(newDv) < 0) {
                    targetArea.devices.push(newDv);
                  }
                }
              }
              if (parsedData[r].uDevices) {
                for (var d in parsedData[r].uDevices) {
                  var newUDv = parsedData[r].uDevices[d];
                  if (targetArea.uDevices.indexOf(newUDv) < 0) {
                    targetArea.uDevices.push(newUDv);
                  }
                }
              }
            }
          }
        }
        _state.isTransportCompleted = true;
      }
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.MOVE_DEVICES_TO_AREAS:
      if (parsedData && parsedData.length > 0) {
        for (var r in parsedData) {
          // parsed data contains 'targetAreaId' , 'devices' , 'oldAreaId'
          var targetArea = findAreaById(
            parsedData[r].targetAreaId || parsedData[r].targetAreaUId
          );
          if (targetArea) {
            if (
              !targetArea.devices ||
              (!targetArea.uDevices !== null &&
                targetArea.uDevices !== undefined &&
                !targetArea.uDevices)
            ) {
              targetArea.devices = parsedData[r]?.devices;
              targetArea.uDevices = parsedData[r]?.uDevices;
            } else {
              if (parsedData[r].devices) {
                for (var d in parsedData[r].devices) {
                  var newDv = parsedData[r].devices[d];
                  if (targetArea.devices.indexOf(newDv) < 0) {
                    targetArea.devices.push(newDv);
                  }
                }
              }
              if (parsedData[r].uDevices) {
                for (var d in parsedData[r].uDevices) {
                  var newUDv = parsedData[r].uDevices[d];
                  if (targetArea.uDevices.indexOf(newUDv) < 0) {
                    targetArea.uDevices.push(newUDv);
                  }
                }
              }
            }
          }
        }
        var oldArea = findAreaById(
          parsedData[0].oldAreaId || parsedData[0].oldAreaUId
        );
        if (oldArea && (oldArea.devices || oldArea.uDevices)) {
          if (oldArea.devices) {
            var removedDevices = parsedData[0].devices;
            for (var r in removedDevices) {
              var idx = oldArea.devices.indexOf(removedDevices[r]);
              if (idx >= 0) {
                oldArea.devices.splice(idx, 1);
              }
            }
          }
          if (oldArea.uDevices) {
            var removedUDevice = parsedData[0].uDevices;
            for (var r in removedUDevice) {
              var idx = oldArea.uDevices.indexOf(removedUDevice[r]);
              if (idx >= 0) {
                oldArea.uDevices.splice(idx, 1);
              }
            }
          }
        }
        _state.isTransportCompleted = true;
      }
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.TRANSPORT_RESULT:
      if (parsedData && parsedData.succeeded) {
        _state.isTransportCompleted = true;
      } else {
        _state.isTransportCompleted = false;
      }
      break;
    case Pre.AREA + Actions.RESET_TRANSPORT_RESULT:
      _state.isTransportCompleted = undefined;
      break;
    case Pre.AREA + Actions.UNLINK_DEVICE:
      if (parsedData) {
        for (var i in _state.areas) {
          if (
            _state.areas[i].areaId == parsedData.areaId ||
            _state.areas[i].areaUId == parsedData.areaUId
          ) {
            var area = _state.areas[i];
            if (
              area.devices &&
              area.devices.length > 0 &&
              parsedData.removedDevices &&
              parsedData.removedDevices.length
            ) {
              var newList = [];
              for (var d in area.devices) {
                if (parsedData.removedDevices.indexOf(area.devices[d]) < 0) {
                  // if is not in removed devices, add again
                  newList.push(area.devices[d]);
                }
              }
              area.devices = newList;
            }
          }
          if (
            area.uDevices &&
            area.uDevices.length > 0 &&
            parsedData.removedUDevices &&
            parsedData.removedUDevices.length
          ) {
            var newList = [];
            for (var d in area.uDevices) {
              if (parsedData.removedUDevices.indexOf(area.uDevices[d]) < 0) {
                // if is not in removed devices, add again
                newList.push(area.uDevices[d]);
              }
            }
            area.devices = newList;
          }
        }
      }
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.MODIFIED:
      _state.isModified = parsedData.isModified || false;
      _state.isLoading = false;
      break;

    case Pre.AREA + Actions.TYPE_ACTIONS:
      // expected array of managers. each manager is an object like :
      // {
      //   manager: "ManagerName",
      //   deviceType : "DEVICE_TYPE_1,DEVICE_TYPE_2",
      //   actions: [{ action: "ActionName", isBatchAction : true ,parameterTypes: ["bool", "byte"] }]
      // }
      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        _state.actionManagers = parsedData;
      }
      _state.isLoading = false;
      break;

    case Pre.AREA + Actions.TYPE_EVENTS:
      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        _state.eventListeners = parsedData;
      }
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.DISARM:
      if (parsedData) {
        for (var i in _state.areas) {
          var area = _state.areas[i];
          if (
            area.areaId == parsedData.areaId ||
            area.areaUId == parsedData.areaUId
          ) {
            area.isArmed = parsedData.isArmed;
            area.isBreached = false;
          }
        }
      }
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.ARM_REPORT:
      if (parsedData) {
        for (var i in _state.areas) {
          var area = _state.areas[i];
          if (
            area.areaId == parsedData.areaId ||
            area.areaUId == parsedData.areaUId
          ) {
            if (!area.armReport) {
              area.armReport = {
                inProgress: true,
              };
            }
            area.armReport.inProgress = true;
            switch (parsedData.task) {
              case "LIGHT":
                area.armReport.shouldTurnOffLights = parsedData.succeeded; // boolean value
                break;
              case "AIR_CONDITIONER":
                area.armReport.shouldTurnOffAirConditioners =
                  parsedData.succeeded; // boolean value
                break;
              case "DOOR_SENSOR":
                area.armReport.shouldCheckDoorWindowsClosed =
                  parsedData.succeeded; // boolean value
                if (
                  Array.isArray(parsedData.openWindows) &&
                  parsedData.openWindows.length > 0
                ) {
                  area.armReport.openWindows = parsedData.openWindows;
                } else {
                  area.armReport.openWindows = [];
                }
                break;
              case "CURTAIN":
                area.armReport.shouldCloseCurtains = parsedData.succeeded; // boolean value
                break;
              case "ARM_SCENARIOS":
                area.armReport.shouldRunScenarios = parsedData.succeeded; // boolean value
                break;
              case "COUNT_DOWN":
                area.armReport.countDown = parsedData.second;
                break;
              case "FINISHED":
                area.isArmed = true;
                area.armReport = {
                  inProgress: false,
                };
                break;
              case "ERROR":
                area.armReport.error = parsedData.error;
                break;
            }
            break;
          }
        }
      }
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.BREACHED:
      if (parsedData) {
        // areaId<number> areaUId<string> isBreached<bool>
        for (var i in _state.areas) {
          var area = _state.areas[i];
          if (
            area.areaId == parsedData.areaId ||
            area.areaUId == parsedData.areaUId
          ) {
            area.isBreached = parsedData.isBreached;
            break;
          }
        }
      }
      _state.isLoading = false;
      break;
    case Pre.AREA + Actions.ARM_REPORT_RESET:
      for (var i in _state.areas) {
        var area = _state.areas[i];
        if (
          area?.areaId == action.payload?.areaId ||
          area.areaUId == action.payload.areaUIdU
        ) {
          area.armReport = {};
        }
      }
      _state.isLoading = false;
      break;

    case Pre.AREA + Actions.ADD_STATE:
      var area = _state.areas.find(
        (a) =>
          a?.areaId == parsedData?.areaId || a.areaUId == parsedData.areaUId
      );
      if (area) {
        if (!Array.isArray(area.userDefinedStates)) {
          area.userDefinedStates = [];
        }
        if (
          !area.userDefinedStates.some(
            (a) => a?.id == parsedData?.id || a.uId == parsedData.uId
          )
        )
          area.userDefinedStates.push(parsedData);
      }
      break;
    case Pre.AREA + Actions.UPDATE_STATE:
      var area = _state.areas.find(
        (a) =>
          a?.areaId == parsedData?.areaId || a.areaUId == parsedData.areaUId
      );
      if (area) {
        if (!Array.isArray(area.userDefinedStates)) {
          area.userDefinedStates = [];
        }
        for (var i = 0; i < area.userDefinedStates.length; i++) {
          if (
            area.userDefinedStates[i]?.id == parsedData?.id ||
            area.userDefinedStates[i].uId == parsedData.uId
          ) {
            area.userDefinedStates[i] = parsedData;
            break;
          }
        }
      }
      break;
    case Pre.AREA + Actions.REMOVE_STATE:
      var area = _state.areas.filter((a) => a.areaId == parsedData.areaId)[0];
      if (area) {
        if (!Array.isArray(area.userDefinedStates)) {
          area.userDefinedStates = [];
        }
        for (var i = 0; i < area.userDefinedStates.length; i++) {
          if (area.userDefinedStates[i].id == parsedData.id) {
            area.userDefinedStates.splice(i, 1);
            break;
          }
        }
      }
      break;
    case Pre.AREA + Actions.ACTIVE_STATE:
      const { stateId: _stateIdActive, stateUId: _stateUIdActive } =
        action.payload;
      if (parsedData) {
        let { areaId, areaUId, stateUId, stateId, autoDisableState } =
          parsedData;
        var area = findAreaById(areaId || areaUId);
        if (area && area.userDefinedStates) {
          for (var i in area.userDefinedStates) {
            if (
              area.userDefinedStates[i].id == stateId ||
              area.userDefinedStates[i].uId == stateUId
            ) {
              if (action.socket.send) {
                area.userDefinedStates[i].isLoading = true;
              } else {
                area.userDefinedStates[i].isLoading = false;
                area.userDefinedStates[i].isActivated = true;
              }
            } else {
              area.userDefinedStates[i].isActivated = false;
            }
          }
          area.autoDisableState = autoDisableState;
        }
      } else if (action.socket.send) {
        var ar = _state.areas.find((a) =>
          a.userDefinedStates.some(
            (s) => s.id == _stateIdActive || s.uId == _stateUIdActive
          )
        );
        if (ar) {
          for (var i in ar.userDefinedStates) {
            if (
              ar.userDefinedStates[i].id == _stateIdActive ||
              ar.userDefinedStates[i].uId == _stateUIdActive
            ) {
              ar.userDefinedStates[i].isLoading = true;
              break;
            }
          }
        }
      }
      break;
    case Pre.AREA + Actions.DE_ACTIVE_STATE:
      const { stateId: _stateId, stateUId: _stateUId } = action.payload;
      if (parsedData) {
        let { areaId, areaUId, stateUId, stateId } = parsedData;
        var area = findAreaById(areaId || areaUId);
        if (area && area.userDefinedStates) {
          for (var i in area.userDefinedStates) {
            if (
              area.userDefinedStates[i].id == stateId ||
              area.userDefinedStates[i].uId == stateUId
            ) {
              if (action.socket.send) {
                area.userDefinedStates[i].isLoading = true;
              } else {
                area.userDefinedStates[i].isLoading = false;
                area.userDefinedStates[i].isActivated = false;
              }
              break;
            }
          }
          area.autoDisableState = null;
        }
      } else if (action.socket.send) {
        var ar = _state.areas.find((a) =>
          a.userDefinedStates.some(
            (s) => s.id == _stateId || s.uId == _stateUId
          )
        );
        if (ar) {
          for (var i in ar.userDefinedStates) {
            if (
              ar.userDefinedStates[i].id == _stateId ||
              ar.userDefinedStates[i].uId == _stateUId
            ) {
              ar.userDefinedStates[i].isLoading = true;
              break;
            }
          }
        }
      }
      break;
    case Pre.AREA + Actions.ON_OCCUPATION_CHANGE:
      if (parsedData.areaId) {
        for (const i in _state.areas) {
          const area = _state.areas[i];
          if (area.areaId == parsedData.areaId) {
            area.isOccupied = parsedData.isOccupied;
            break;
          }
        }
      }
      break;
    case Pre.AREA + Actions.TEST:
      console.log("area reducer received test", action.type, action.payload);
      _state.isLoading = false;
      break;
    // case Pre.APP + Actions.RECONNECT:
    //   console.log("APP_RECONNECT received in AreaReducer");
    //   _state.list = [];
    //   break;
    // === Area Pin Code ===
    case Pre.AREA + Actions.ASK_PIN:
      if (parsedData) {
        _state.touchPanelAlert = parsedData;
      }
      break;
    case Pre.AREA + Actions.ASK_PIN_CLEAR:
      _state.touchPanelAlert = null;
      break;

    case Pre.BUILDING + Actions.ALL_CACHE:
      // if (_state.buildingsLoaded) break;
      // new CacheStorage().buildings
      //   .GetAll()
      //   .then((cachedBuildings) => {
      //     // console.log(
      //     //   "load buildings list from cache in area reducer",
      //     //   cachedBuildings
      //     // );
      //     var _buildings = [...state.buildings];
      //     for (let i = 0; i < cachedBuildings.length; i++) {
      //       const cachedBuilding = cachedBuildings[i];
      //       var duplicatedBuilding = _buildings.filter(
      //         (b) => b.buildingId == cachedBuilding.buildingId
      //       )[0];
      //       if (duplicatedBuilding) {
      //         console.log(
      //           "skip re load duplicated building",
      //           duplicatedBuilding.buildingId,
      //           duplicatedBuilding.buildingName
      //         );
      //       } else {
      //         _buildings.push(cachedBuilding);
      //       }
      //     }
      //     _state.buildings = _buildings;
      //     console.log("load buildings from cache", _state.buildings.length);
      //   })
      //   .catch((e) => {
      //     console.log("error on AreaReducer.BUILDING_LOAD", e);
      //   });
      break;
    case Pre.BUILDING + Actions.ALL:
      var _buildings = [];
      var newBuildings = [...parsedData.buildings];
      for (const i in newBuildings) {
        const building = newBuildings[i];
        if (!_buildings.some((b) => b.buildingId == building.buildingId)) {
          _buildings.push({ ...building });
        } else {
          var existed = _buildings.filter(
            (b) => b.buildingId == building.buildingId
          )[0];
          _buildings[_buildings.indexOf(existed)] = building;
        }
      }

      _state.buildings = _buildings;
      _state.buildingsLoaded = true;
      new CacheStorage().buildings.SetAll(_buildings);

      break;
    case Pre.SMART_PARKING + Actions.ALL:
      // console.log('parsedData.length in reducer parking_all', typeof parsedData, parsedData.length)
      // console.log('parsedData in reducer parking_all', typeof parsedData, parsedData)
      if (Array.isArray(parsedData)) {
        _state.parkings = [...parsedData];
        _state.parkingsLoaded = true;
      }
      break;
    case Pre.SMART_PARKING + Actions.ADD:
      // console.log("model", parsedData);
      _state.parkings.push(parsedData);
      // _state.parkings = [..._state.parkings, action.payload.data];
      // if (model.id) {
      //   for (var ar in _state.parkings) {
      //     if (_state.parkings[ar].id == model.id) {
      //       // if (!_state.parkings[ar].subAreas) _state.parkings[ar].parkingAreas = [];
      //       // _state.areas[ar].subAreas.push(model);
      //       break;
      //     }
      //   }
      // }
      // _state.isLoading = false;
      break;
    case Pre.SMART_PARKING + Actions.UPDATE:
      _state.parkings = [..._state.parkings];
      if (parsedData?.id || parsedData?.uId) {
        for (var index in _state.parkings) {
          if (
            _state.parkings[index]?.id == parsedData?.id ||
            _state.parkings[index]?.uId == parsedData?.uId
          ) {
            _state.parkings[index] = parsedData;
          }
        }
      }
      break;
    case Actions.CLEAR_CACHE:
    case Actions.LOGOUT:
      // console.log("clear AreaReducer due to LOGOUT");
      _state.actionManagers = [];
      _state.areas = [];
      _state.areasCount = 0;
      //_state.buildings = [];
      _state.buildingsLoaded = false;
      _state.eventListeners = [];
      new CacheStorage().Areas.ClearAll();
      break;
    case Pre.ACCESS_CONTROL + Actions.PLAY_SOUND_ALARM:
      _state.isPlayingAlarm = true;
      break;
    case Pre.ACCESS_CONTROL + Actions.STOP_SOUND_ALARM:
      _state.isPlayingAlarm = false;
      break;

  }

  //console.log("_state.buildings", _state.buildings.length, action.type);
  return _state;
};

export default AreaReducer;
